// extracted by mini-css-extract-plugin
module.exports = {"flex":"UpdatedEmail_flex_212bL","comment":"UpdatedEmail_comment_qYXQP","message":"UpdatedEmail_message_X5uUb","btn":"UpdatedEmail_btn_Lvjbw","bdr":"UpdatedEmail_bdr_24zcm"};